/**
 * Organization Management Page (T-ORG-005)
 * Handles organization list, create, settings, and member management
 */

import type { QueryClient } from "@tanstack/react-query"
import { Outlet, createFileRoute, redirect } from "@tanstack/react-router"

import { OrganizationsService, type UserPublic } from "@/client"

export const Route = createFileRoute("/_layout/organizations")({
  component: OrganizationsLayout,
  beforeLoad: async ({ context }) => {
    const queryClient = (context as { queryClient: QueryClient }).queryClient
    const currentUser = queryClient.getQueryData<UserPublic>(["currentUser"])

    // Allow superusers
    if (currentUser?.is_superuser) {
      return
    }

    // For non-superusers, check if they have admin access to any organization
    try {
      const organizations = await queryClient.fetchQuery({
        queryKey: ["organizations"],
        queryFn: () => OrganizationsService.listOrganizations(),
      })

      // If no organizations returned, user is not an admin of any org
      if (!organizations.data || organizations.data.length === 0) {
        throw redirect({
          to: "/",
        })
      }
    } catch (error) {
      // If error or no access, redirect to dashboard
      throw redirect({
        to: "/",
      })
    }
  },
})

function OrganizationsLayout() {
  return <Outlet />
}
